import { TriageAlertState } from '~domain/entities/TriageAlertState';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { UserRepository } from '~repositories/UserRepository';
import { UserStateResolverService } from '~services/UserStateResolverService';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';

export class TriageAlertDisplayedUseCase {
    private configRepository: ConfigRepository;
    private userRepository: UserRepository;
    private userStateResolver: UserStateResolverService;

    constructor() {
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.userRepository = diContainer.get(serviceNames.userRepository);
        this.userStateResolver = new UserStateResolverService(
            this.userRepository.matchedExistingUsers
        );
    }

    public execute = () => {
        const { rampCommon: { siteType } = {} } = this.configRepository;
        const { cacheUserProfileChanges, setTriageAlertState } = this.userRepository;
        // Profile in payload matches to any complete user, so the user is able to login
        const { isCompleteUserFound } = this.userStateResolver;
        const state = new TriageAlertState();
        state.visible = true;
        state.shouldShowSignInButton = siteType === 'ecommerce' && isCompleteUserFound;
        if (isCompleteUserFound) {
            cacheUserProfileChanges();
        }
        setTriageAlertState(state);
    };
}
